import React from 'react';
import { Translate, useI18n } from '@whizz/react-i18n';
import AdminUserImg from '../../assets/Cluedo-Nudges-Teachers-Admin.svg';
import { Alert } from '../../components';
import { useAdminModal } from '../modals/AdminModal';

const NoClasses = () => {

  const { translate } = useI18n();
  const [ adminModal, toggleAdminModal ] = useAdminModal();

  return (
    <>
      <div className={'flex justify-center items-center m-md'}>
        <img src={AdminUserImg} className={'w-72'} />
      </div>
      <Alert show>
        <div className={'space-y-6'}>
          <p>{translate('pages.HOME.NO_CLASSES.line1')}</p>
          <p>
            <Translate i18nKey={'pages.HOME.NO_CLASSES.line2'}>
              {/**
               * eslint-disable-next-line @typescript-eslint/ban-ts-comment
               * @ts-ignore **/ }
              <span onClick={() => toggleAdminModal(true)} className={'underline cursor-pointer'} />
            </Translate>
          </p>
        </div>
      </Alert>
      {adminModal}
    </>
  );
};

export default NoClasses;
